import React, { useEffect } from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import GroupCard from '../components/GroupCard'
import { Link, useOutletContext } from 'react-router-dom'


function Groups() {
    const [page, setPage] = React.useState('groups');
    const [handlegroup, setHandlegroup] = React.useState('');
    const [groups, setGroups] = React.useState('');
    const {user, token} = useOutletContext();
    const [loading, setLoading] = React.useState(false);
    const handleGroups = (e) => {
        setHandlegroup({ ...handlegroup, [e.target.name]: e.target.value });
    };
    const createGroup = (e) => {
    e.preventDefault(); 
    setLoading(true);
      const groupdata = new FormData();
      groupdata.append('name', handlegroup.name);

      groupdata.append('description', handlegroup.group_description);
        fetch('/api/create-group', {
            method: 'POST',
            headers: {
              'Authorization': 'Bearer ' + token,
            },
            body: groupdata
            ,
          })
            .then((response) => response.json())
            .then((data) => {
             if(data.errors){
              setErrors(data.errors)
             }
              else if(data.message){
                setPage('groups');
              }
            })
            .catch((error) => {
              console.log(error);
            }).finally(() => {
              setLoading(false);
            });
    
    }
    const getGroups = () => {
        fetch('/api/get-groups', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => response.json())
            .then((data) => {
                setGroups(data.data);
        }).catch((error) => {
                
            });
    }
    const myGroups = () => {
        fetch('/api/my-groups', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => response.json())
            .then((data) => {
                setGroups(data.data);
        }).catch((error) => {
                
            });
    }
    useEffect(() => {
        if(page === 'groups'){

            getGroups();
        }
        else if(page === 'my-group'){
            myGroups();
        }
        console.log(page);
    },[page]);
  return (
      <div>
        {loading && <div className="preloader"></div>}
          <Header />
          <Leftmenu />
          <Rightmenu />
          <div className="main-content right-chat-active">
              <div className="middle-sidebar-bottom">
                  <div className="middle-sidebar-left">
                          {page === 'groups' &&
                      <div className="row">
                          <div className="col-12">
                              <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3">
                                  <div className="card-body d-flex align-items-center p-0">
                                      <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">
                                          Groups
                                      </h2>
                                  </div>
                              </div>
                          </div>
                          {(user?.role === 'admin' || user?.role === 'faculty') && (
                        <div className="col-md-4 col-sm-6 pe-2 ps-2">
                              <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                                  <div
                                      className="card-body position-relative h100 bg-image-cover bg-image-center"
                                      style={{
                                          backgroundImage:
                                          "url(images/bb-16.png)",
                                        }}
                                        />
                                  <div className="card-body d-block w-100 px-2 text-left position-relative">
                                                                        
                                      <h4 className="fw-700 font-xsss mt-3 mb-1">
                                      </h4>
                                      <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">
                                      </p>
                                      <span className=" w-100 top-0 d-flex align-items-center">
                                          <div onClick={() => setPage('create-group')}
                                              className="text-center bg-current my-2 py-2 w-100 ls-lg text-white cursor-pointer"
                                              >
                                              Create Group
                                          </div>
                                      </span>
                                      <span className=" w-100 top-0 d-flex align-items-center">
                                          <div onClick={() => setPage('my-group')}
                                              className="text-center my-2 bg-current my-2 py-2 w-100 ls-lg text-white cursor-pointer"
                                              >
                                              My Groups
                                          </div>
                                      </span>
                                  </div>
                              </div>
                          </div>
                          )}
                            {
                                groups.length > 0 && groups.map((group) => (
                                    <GroupCard group={group} key={group.id} />
                                ))
                            }
                      </div>
                            }
                          {page === 'my-group' &&
                      <div className="row">
                          <div className="col-12">
                              <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3">
                                  <div className="card-body d-flex align-items-center p-0">
                                      <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">
                                          Groups
                                      </h2>
                                  </div>
                              </div>
                          </div>
                          {(user?.role === 'admin' || user?.role === 'faculty') && (
                        <div className="col-md-4 col-sm-6 pe-2 ps-2">
                              <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                                  <div
                                      className="card-body position-relative h100 bg-image-cover bg-image-center"
                                      style={{
                                          backgroundImage:
                                          "url(images/bb-16.png)",
                                        }}
                                        />
                                  <div className="card-body d-block w-100 px-2 text-left position-relative">
                                                                        
                                      <h4 className="fw-700 font-xsss mt-3 mb-1">
                                      </h4>
                                      <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">
                                      </p>
                                      <span className=" w-100 top-0 d-flex align-items-center">
                                          <div onClick={() => setPage('create-group')}
                                              className="text-center bg-current my-2 py-2 w-100 ls-lg text-white cursor-pointer"
                                              >
                                              Create Group
                                          </div>
                                      </span>
                                      <span className=" w-100 top-0 d-flex align-items-center">
                                          <div onClick={() => setPage('groups')}
                                              className="text-center bg-current my-2 py-2 w-100 ls-lg text-white cursor-pointer"
                                              >
                                              All Groups
                                          </div>
                                                  </span>
                                 
                                  </div>
                              </div>
                          </div>
                          )}
                            {
                                groups.length > 0 && groups.map((group) => (
                                    <GroupCard group={group} key={group.id} />
                                ))
                            }
                      </div>
                            }
                            {page === 'create-group' &&
                              <div
                                    className=""
                                    style={{ minHeight: "100vh" }}
                                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <div onClick={() => setPage('groups')} className="d-flex align-items-center cursor-pointer">
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </div>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                           Create Group
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form onSubmit={createGroup}>
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Group Name
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            className="form-control"
                                                            onChange={handleGroups}
                                                          
                                                           
                                                            required
                                                        />
                                                       
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Group Description
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            type="text"
                                                            name="group_description"
                                                            className="form-control"
                                                            
                                                            onChange={handleGroups}
                                                           
                                                            required
                                                        />
                                                       
                                                    </div>
                                                </div>
                                             
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <button
                                                            type="submit"
                                                            className="btn bg-current text-white btn-block fw-600 font-xsss lh-42 w-100"
                                                        >
                                                            Create Group
                                                        </button>
                                                    </div>
                                                </div>
                                             
                                                
                                           
                                               
                                                
                                          
                                            </div>
                                  
                                          
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                            }
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Groups